export default{
    navbar:{
        home:"首页"
    }
}
